import { render, staticRenderFns } from "./Publicacion.vue?vue&type=template&id=74e2e886&scoped=true&"
import script from "./Publicacion.vue?vue&type=script&lang=ts&"
export * from "./Publicacion.vue?vue&type=script&lang=ts&"
import style1 from "./Publicacion.vue?vue&type=style&index=1&id=74e2e886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e2e886",
  null
  
)

export default component.exports